<template>
    <div class="data_box">
        <div class="details" v-if="type == 1">
            <div class="item_box">
                <div class="box_title">PM 2.5 浓度监测</div>
                <div class="box_cont">
                    <div class="cont_left">
                        <img src="../../../../assets/images/pm25.png" mode="" />
                    </div>
                    <div class="cont_right">
                        <div class="right_one">
                            <div class="text">实时：<span
                                    class="t_size">{{ currentRecord.pm2p5?currentRecord.pm2p5:0 }}</span> μg/m³</div>
                        </div>
                        <div class="right_two">
                            <div class="text">国控值：<span
                                    class="t_size">{{ currentRecord.pm2p5_1h?currentRecord.pm2p5_1h:0 }}</span> μg/m³
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="item_box">
                <div class="box_title">PM 10 浓度监测</div>
                <div class="box_cont">
                    <div class="cont_left">
                        <img src="../../../../assets/images/pm10.png" mode="" />
                    </div>
                    <div class="cont_right">
                        <div class="right_one">
                            <div class="text">实时：<span
                                    class="t_size">{{ currentRecord.pm10?currentRecord.pm10:0 }}</span> μg/m³</div>
                        </div>
                        <div class="right_two">
                            <div class="text">国控值：<span
                                    class="t_size">{{ currentRecord.pm10_1h?currentRecord.pm10_1h:0 }}</span> μg/m³
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="details" v-else-if="type == 2">
            <div class="item_box">
                <div class="box_title">噪音监测</div>
                <div class="box_cont">
                    <div class="cont_body">
                        <img src="../../../../assets/images/noise.png" />
                        <div class="text"><span class="t_size">{{ currentRecord.noise?currentRecord.noise:0 }}</span> 分贝
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="details" v-else-if="type == 3">
            <div class="item_box">
                <div class="box_title">PM 2.5 浓度监测</div>
                <div class="box_cont">
                    <div class="cont_left">
                        <img src="../../../../assets/images/pm25.png" mode="" />
                    </div>
                    <div class="cont_right">
                        <div class="right_one">
                            <div class="text">实时：<span
                                    class="t_size">{{ currentRecord.pm2p5?currentRecord.pm2p5:0 }}</span> μg/m³</div>
                        </div>
                        <div class="right_two">
                            <div class="text">国控值：<span
                                    class="t_size">{{ currentRecord.pm2p5_1h?currentRecord.pm2p5_1h:0 }}</span> μg/m³
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="item_box">
                <div class="box_title">PM 10 浓度监测</div>
                <div class="box_cont">
                    <div class="cont_left">
                        <img src="../../../../assets/images/pm10.png" mode="" />
                    </div>
                    <div class="cont_right">
                        <div class="right_one">
                            <div class="text">实时：<span
                                    class="t_size">{{ currentRecord.pm10?currentRecord.pm10:0 }}</span> μg/m³</div>
                        </div>
                        <div class="right_two">
                            <div class="text">国控值：<span
                                    class="t_size">{{ currentRecord.pm10_1h?currentRecord.pm10_1h:0 }}</span> μg/m³
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="item_box">
                <div class="box_title">风力/风速</div>
                <div class="box_cont">
                    <div class="left_box">
                        <div class="box_text">风力</div>
                        <div class="box_text"><img src="../../../../assets/images/windspeed.png" /></div>
                        <div class="box_text"><span
                                class="t_size">{{ currentRecord.wind_grade?currentRecord.wind_grade:0 }}</span> 级</div>
                    </div>
                    <div class="right_box">
                        <div class="box_text">风速</div>
                        <div class="box_text"><img src="../../../../assets/images/speed.png" /></div>
                        <div class="box_text"><span
                                class="t_size">{{ currentRecord.wind_speed?currentRecord.wind_speed:0 }}</span> m/s
                        </div>
                    </div>
                </div>
            </div>


            <div class="item_box">
                <div class="box_title">雨量</div>
                <div class="box_cont">
                    <div class="cont_left">
                        <img src="../../../../assets/images/rainfall.png" />
                    </div>
                    <div class="cont_right">
                        <div class="right_one">
                            <div class="text" style="font-size: 14px;">瞬时：<span
                                    class="t_size">{{ currentRecord.rainfall_min?currentRecord.rainfall_min:0 }}</span>
                                mm/m</div>
                        </div>

                        <div class="right_one" style="font-size: 14px;">
                            <div class="text">小时：<span
                                    class="t_size">{{ currentRecord.rainfall_hour?currentRecord.rainfall_hour:0 }}</span>
                                mm/h</div>
                        </div>
                        <div class="right_two" style="font-size: 14px;">
                            <div class="text">当日：<span
                                    class="t_size">{{ currentRecord.rainfall_day?currentRecord.rainfall_day:0 }}</span>
                                mm/d
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="item_box" style="width: 170px;margin-right: 10px;">
                <div class="box_title" style="width: 170px;">风向监测</div>
                <div class="box_cont" style="width: 170px;">
                    <div class="cont_body" style="flex-direction: column;">
                        <img src="../../../../assets/images/direction.png"
                            style="width: 45px;height: 45px;margin:15px;" />
                        <div class="text"><span
                                class="t_size">{{ currentRecord.wind_direction_location?fnToggleText(currentRecord.wind_direction_location):'无' }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="item_box" style="width: 170px;margin-right: 10px;">
                <div class="box_title" style="width: 170px;">温度监测</div>
                <div class="box_cont" style="width: 170px;">
                    <div class="cont_body" style="flex-direction: column;">
                        <img src="../../../../assets/images/temp.png" style="width: 45px;height: 45px;margin:15px;" />
                        <div class="text"><span
                                class="t_size">{{ currentRecord.temperature?currentRecord.temperature:0 }}</span> ℃
                        </div>
                    </div>
                </div>
            </div>
            <div class="item_box" style="width: 170px;margin-right: 10px;">
                <div class="box_title" style="width: 170px;">湿度监测</div>
                <div class="box_cont" style="width: 170px;">
                    <div class="cont_body" style="flex-direction: column;">
                        <img src="../../../../assets/images/wet.png" style="width: 45px;height: 45px;margin:15px;" />
                        <div class="text"><span
                                class="t_size">{{ currentRecord.humidity?currentRecord.humidity:0 }}</span> %</div>
                    </div>
                </div>
            </div>
            <div class="item_box" style="width: 170px;margin-right: 10px;">
                <div class="box_title" style="width: 170px;">噪音监测</div>
                <div class="box_cont" style="width: 170px;">
                    <div class="cont_body" style="flex-direction: column;">
                        <img src="../../../../assets/images/noise.png" style="width: 45px;height: 45px;margin:15px;" />
                        <div class="text"><span class="t_size">{{ currentRecord.noise?currentRecord.noise:0 }}</span> 分贝
                        </div>
                    </div>
                </div>
            </div>
            <div class="item_box" style="width: 170px;margin-right: 10px;">
                <div class="box_title" style="width: 170px;">悬浮颗粒物监测</div>
                <div class="box_cont" style="width: 170px;">
                    <div class="cont_body" style="flex-direction: column;">
                        <img src="../../../../assets/images/grain.png" style="width: 45px;height: 45px;margin:15px;" />
                        <div class="text"><span class="t_size">{{ currentRecord.TSP?currentRecord.TSP:0 }}</span> μg/m³
                        </div>
                    </div>
                </div>
            </div>
            <div class="item_box" style="width: 170px;margin-right: 10px;">
                <div class="box_title" style="width: 170px;">环境光照度</div>
                <div class="box_cont" style="width: 170px;">
                    <div class="cont_body" style="flex-direction: column;">
                        <img src="../../../../assets/images/light.png"
                            style="width: 45px;height: 45px;margin:15px;" />
                        <div class="text"><span
                                class="t_size">{{ currentRecord.light?currentRecord.light:0 }}</span>
                            lux
                        </div>
                    </div>
                </div>
            </div>
            <div class="item_box" style="width: 170px;margin-right: 10px;">
                <div class="box_title" style="width: 170px;">太阳总辐射</div>
                <div class="box_cont" style="width: 170px;">
                    <div class="cont_body" style="flex-direction: column;">
                        <img src="../../../../assets/images/total_solar_radiation.png"
                            style="width: 45px;height: 45px;margin:15px;" />
                        <div class="text"><span
                                class="t_size">{{ currentRecord.total_solar_radiation?currentRecord.total_solar_radiation:0 }}</span>
                            W/m2
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="details" v-else-if="type == 4">
            <div class="item_box">
                <div class="box_title">水质PH</div>
                <div class="box_cont">
                    <div class="cont_body">
                        <img src="../../../../assets/images/water_quality_ph.png" />
                        <div class="text"><span
                                class="t_size">{{ currentRecord.water_quality_ph?currentRecord.water_quality_ph:0 }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="item_box">
                <div class="box_title">水质浊度</div>
                <div class="box_cont">
                    <div class="cont_body">
                        <img src="../../../../assets/images/water_quality_turbidity.png" />
                        <div class="text"><span
                                class="t_size">{{ currentRecord.water_quality_turbidity?currentRecord.water_quality_turbidity:0 }}</span>
                            NTU
                        </div>
                    </div>
                </div>
            </div>
            <div class="item_box">
                <div class="box_title">水质导电率</div>
                <div class="box_cont">
                    <div class="cont_body">
                        <img src="../../../../assets/images/water_conductivity.png" />
                        <div class="text"><span
                                class="t_size">{{ currentRecord.water_conductivity?currentRecord.water_conductivity:0 }}</span>
                            us/cm</div>
                    </div>
                </div>
            </div>
            <div class="item_box">
                <div class="box_title">水质溶解氧</div>
                <div class="box_cont">
                    <div class="cont_body">
                        <img src="../../../../assets/images/water_dissolved_oxygen.png" />
                        <div class="text"><span
                                class="t_size">{{ currentRecord.water_dissolved_oxygen?currentRecord.water_dissolved_oxygen:0 }}</span>
                            mg/L
                        </div>
                    </div>
                </div>
            </div>
            <div class="item_box">
                <div class="box_title">水质COD</div>
                <div class="box_cont">
                    <div class="cont_body">
                        <img src="../../../../assets/images/water_cod.png" />
                        <div class="text"><span
                                class="t_size">{{ currentRecord.water_cod?currentRecord.water_cod:0 }}</span> mg/L
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="details" v-else-if="type == 5">
            <div class="item_box">
                <div class="box_title">空气质量 TVOC</div>
                <div class="box_cont">
                    <div class="cont_body">
                        <img src="../../../../assets/images/tvoc.png" />
                        <div class="text"><span
                                class="t_size">{{ currentRecord.air_quality?currentRecord.air_quality:0 }}</span> ug/m3
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="details" v-else>
            <div class="item_box">
                <div class="box_title">PM 2.5 浓度监测</div>
                <div class="box_cont">
                    <div class="cont_left">
                        <img src="../../../../assets/images/pm25.png" mode="" />
                    </div>
                    <div class="cont_right">
                        <div class="right_one">
                            <div class="text">实时：<span
                                    class="t_size">{{ currentRecord.pm2p5?currentRecord.pm2p5:0 }}</span> μg/m³</div>
                        </div>
                        <div class="right_two">
                            <div class="text">国控值：<span
                                    class="t_size">{{ currentRecord.pm2p5_1h?currentRecord.pm2p5_1h:0 }}</span> μg/m³
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="item_box">
                <div class="box_title">PM 10 浓度监测</div>
                <div class="box_cont">
                    <div class="cont_left">
                        <img src="../../../../assets/images/pm10.png" mode="" />
                    </div>
                    <div class="cont_right">
                        <div class="right_one">
                            <div class="text">实时：<span
                                    class="t_size">{{ currentRecord.pm10?currentRecord.pm10:0 }}</span> μg/m³</div>
                        </div>
                        <div class="right_two">
                            <div class="text">国控值：<span
                                    class="t_size">{{ currentRecord.pm10_1h?currentRecord.pm10_1h:0 }}</span> μg/m³
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="item_box">
                <div class="box_title">风力/风速</div>
                <div class="box_cont">
                    <div class="left_box">
                        <div class="box_text">风力</div>
                        <div class="box_text"><img src="../../../../assets/images/windspeed.png" /></div>
                        <div class="box_text"><span
                                class="t_size">{{ currentRecord.wind_grade?currentRecord.wind_grade:0 }}</span> 级</div>
                    </div>
                    <div class="right_box">
                        <div class="box_text">风速</div>
                        <div class="box_text"><img src="../../../../assets/images/speed.png" /></div>
                        <div class="box_text"><span
                                class="t_size">{{ currentRecord.wind_speed?currentRecord.wind_speed:0 }}</span> m/s
                        </div>
                    </div>
                </div>
            </div>
            <div class="item_box">
                <div class="box_title">风向监测</div>
                <div class="box_cont">
                    <div class="cont_body">
                        <img src="../../../../assets/images/direction.png" />
                        <div class="text"><span
                                class="t_size">{{ currentRecord.wind_direction_location?fnToggleText(currentRecord.wind_direction_location):'无' }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="item_box">
                <div class="box_title">温度监测</div>
                <div class="box_cont">
                    <div class="cont_body">
                        <img src="../../../../assets/images/temp.png" />
                        <div class="text"><span
                                class="t_size">{{ currentRecord.temperature?currentRecord.temperature:0 }}</span> ℃
                        </div>
                    </div>
                </div>
            </div>
            <div class="item_box">
                <div class="box_title">湿度监测</div>
                <div class="box_cont">
                    <div class="cont_body">
                        <img src="../../../../assets/images/wet.png" />
                        <div class="text"><span
                                class="t_size">{{ currentRecord.humidity?currentRecord.humidity:0 }}</span> %</div>
                    </div>
                </div>
            </div>
            <div class="item_box">
                <div class="box_title">噪音监测</div>
                <div class="box_cont">
                    <div class="cont_body">
                        <img src="../../../../assets/images/noise.png" />
                        <div class="text"><span class="t_size">{{ currentRecord.noise?currentRecord.noise:0 }}</span> 分贝
                        </div>
                    </div>
                </div>
            </div>
            <div class="item_box">
                <div class="box_title">悬浮颗粒物监测</div>
                <div class="box_cont">
                    <div class="cont_body">
                        <img src="../../../../assets/images/grain.png" />
                        <div class="text"><span class="t_size">{{ currentRecord.TSP?currentRecord.TSP:0 }}</span> μg/m³
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="indicator">
            <div class="today">
                <div class="title">今日数据统计</div>
                <div class="con">
                    <div class="con_box">
                        <div class="box_title">预报警</div>
                        <div class="box_count">
                            <span>{{ warningCount }}</span>
                            次
                        </div>
                        <div class="box_btn">
                            <div class="search-btn orange" @click="fnOpenAlarmWin"><span>查看详情</span></div>
                        </div>
                    </div>
                    <div class="con_box">
                        <div class="box_title">报警提示</div>
                        <div class="box_msg" v-if="currentRecord.status">
                            <div class="alarms" v-for="(p, i) in fnChangeStatus(currentRecord.status)" :key="i">{{ p }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="security">
                <div class="title">统计预警率</div>
                <div class="con">
                    <div class="safety-rate" id="safety-rate-chart" ref="safetyRate"></div>
                </div>
            </div>
        </div>
        <div class="environment_chart">
            <div id="environment-chart" class="chart-container" ref="container"></div>
            <div class="open-dateils">
                <div @click="fnOpenRealTimeWin" class="search-btn orange"><span>查看详情</span></div>
            </div>
        </div>
    </div>
</template>
<script>
    import echarts from 'echarts';
    require('echarts/theme/macarons'); // echarts theme
    import request from '@/utils/request';
    import APP from '@/utils/base';
    export default {
        props: {
            currentEnvironment: {
                type: Object
            }
        },
        data() {
            return {
                timer: null,
                safetyRateChart: null, // 安全统计图
                safetyRate: 100, // 安全统计
                EnviromentChart: null,
                currentRecord: {}, // 设备当前最新一条实时记录
                warningCount: 0, // 预报警条数统计
                recordCount: 1, // 记录条数统计
                chartDataX: [], // 统计图X轴数据
                pm25Y: [], // 统计图pm25数据
                pm10Y: [], // 统计图pm10数据
                noiseY: [], // 统计图噪音数据
                tempY: [], // 统计图温度数据
                wetY: [], // 统计图湿度数据
                lightY: [], // 统计图环境光照度数据
                airQualityY: [], // 统计图空气质量tvoc数据
                totalSolarRadiationY: [], // 统计图太阳总辐射数据
                rainfallHourY: [], // 统计图小时雨量数据
                rainfallMinY: [], // 统计图瞬时雨量数据
                rainfallDayY: [], // 统计图当日总雨量数据
                waterQualityPhY: [], // 统计图水质Ph度数据
                waterQualityTurbidityY: [], // 统计图水质浊度数据
                waterConductivityY: [], // 统计图水质导电率数据
                waterDissolvedOxygenY: [], // 统计图水质溶解氧数据
                waterCodY: [], // 统计图水质COD数据
                targetHeight: 60,
                anchorLeft: 31,
                type: 0,
                currentEnvironmentNew: {
                    eqptStatus: '',
                    number: '',
                    nowTime: '',
                }
            };
        },
        watch: {
            currentEnvironment: {
                immediate: true,
                deep: true,
                handler: function(newV, oldV) {

                    if (oldV && newV) {
                        this.type = newV.type;
                        if (newV.nowTime >= oldV.nowTime) {
                            this.fnGetChartData();
                            this.fnGetTodayRecord();
                        }
                    }
                    if (newV === 'undefined') {
                        this.currentEnvironmentNew = {
                            eqptStatus: '',
                            number: '',
                            nowTime: ''
                        };
                        this.type = 0;
                    } else {
                        this.currentEnvironmentNew.eqptStatus = newV.eqptStatus;
                        this.currentEnvironmentNew.number = newV.number;
                        this.type = newV.type;
                    }

                    this.type = this.type ? this.type : 0

                    this.fnGetTodayRecord();
                    this.fnGetChartData();
                }
            }
        },
        beforeDestroy() {
            clearInterval(this.timer);
        },
        methods: {
            fnToggleText(status) {
                switch (status) {
                    case 0:
                        return '北风';
                    case 1:
                        return '东北风';
                    case 2:
                        return '东风';
                    case 3:
                        return '东南风';
                    case 4:
                        return '南风';
                    case 5:
                        return '西南风';
                    case 6:
                        return '西风';
                    case 7:
                        return '西北风';
                    default:
                        return '';
                }
            },
            // 扬尘运行状态
            fnEnvrionmentStatusToText(_status) {
                return APP.fnCraneStatusToText(_status, 'environment');
            },
            // 获取报警值转数组
            fnChangeStatus(status) {
                var _text = this.fnEnvrionmentStatusToText(status);
                var text = _text.text;
                var arr = text.split(',');
                return arr;
            },
            // 查看预报警记录
            fnOpenAlarmWin() {
                this.$parent.fnOpenEnvironmentAlarm();
            },
            // 查看运行记录
            fnOpenRealTimeWin() {
                this.$parent.fnOpenEnvironmentRealTimeRecord();
            },
            // 预报警率
            fnSafetyRateChart() {
                this.safetyRateChart = echarts.init(this.$refs.safetyRate);
                this.safetyRateChart.setOption({
                    title: {
                        text: '预报警率',
                        left: '20px',
                        textStyle: {
                            color: '#fff'
                        }
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b}: {c} ({d}%)'
                    },
                    legend: {
                        orient: 'vertical',
                        x: 'left',
                        show: false,
                        data: ['预报警率', '错误数量']
                    },
                    series: [{
                        name: '预报警统计',
                        type: 'pie',
                        radius: ['50%', '70%'],
                        avoidLabelOverlap: false,
                        label: {
                            normal: {
                                position: 'center'
                            },
                            emphasis: {
                                show: true,
                                textStyle: {
                                    fontSize: '16',
                                    fontWeight: 'bold'
                                }
                            }
                        },
                        labelLine: {
                            normal: {
                                show: false
                            }
                        },
                        data: [{
                                value: this.recordCount - this.warningCount,
                                itemStyle: {
                                    color: '#ECC64D'
                                },
                                name: '正常占比'
                            },
                            {
                                value: this.warningCount,
                                label: {
                                    show: false
                                },
                                name: '预报警占比'
                            }
                        ]
                    }]
                });
            },
            // 获取扬尘实时数据记录公共方法
            fnGetEnvironmentRecord(_obj, _cb, _err) {
                request({
                        notLoading: true,
                        url: 'environmental/getRecord',
                        method: 'GET',
                        params: _obj
                    })
                    .then(res => {
                        _cb && _cb(res.data);
                    })
                    .catch(err => {
                        _err && _err(err.data);
                    });
            },
            // 获取扬尘当天实时记录
            fnGetTodayRecord() {
                let _that = this;
                if (!_that.currentEnvironmentNew.number) return;
                let _myDate = new Date().Format('yyyy-MM-dd');
                let _startTime = _myDate + ' 00:00:00';
                let _endTime = _myDate + ' 23:59:59';
                let _createAt = _startTime + ',' + _endTime;
                let _recordArr = [];
                let _cycleArr = [];
                let _recordPage = 1;
                let _cyclePage = 1;
                let _size = 50;
                let _warning = 0; // 预报警信息统计
                let _cycle = 0; // 吊装记录统计
                _fnGetRecord(() => {
                    _that.fnGetEnvironmentRecord({
                            number: _that.currentEnvironmentNew.number,
                            page: 1,
                            size: 1,
                            create_at: _createAt,
                            is_alarm: 1
                        },
                        res => {
                            _that.warningCount = res.count;
                            setTimeout(() => {
                                _that.fnSafetyRateChart();
                            }, 100);
                        },
                        err => {
                            _that.warningCount = 0;
                            setTimeout(() => {
                                _that.fnSafetyRateChart();
                            }, 100);
                        }
                    );
                });
                // 获取实时记录总条数
                function _fnGetRecord(_cb) {
                    _that.fnGetEnvironmentRecord({
                            number: _that.currentEnvironmentNew.number,
                            page: 1,
                            size: 1,
                            create_at: _createAt
                        },
                        res => {
                            _that.recordCount = res.count ? res.count : 1;
                            _cb && _cb();
                        },
                        err => {
                            _that.recordCount = 1;
                            _cb && _cb();
                        }
                    );
                }
            },
            // 获取塔机统计图数据
            fnGetChartData() {

                let _myDate = new Date().getTime();
                let _index = 0;
                let _chartDataX = [];
                let _pm25Y = [];
                let _pm10Y = [];
                let _noiseY = [];
                let _tempY = [];
                let _wetY = [];
                let _lightY = [];
                let _airQualityY = [];
                let _totalSolarRadiationY = [];
                let _rainfallHourY = [];
                let _rainfallMinY = [];
                let _rainfallDayY = [];
                let _waterQualityPhY = [];
                let _waterQualityTurbidityY = [];
                let _waterConductivityY = [];
                let _waterDissolvedOxygenY = [];
                let _waterCodY = [];

                if (!this.currentEnvironmentNew.number) {
                    while (_index < 20) {
                        _myDate -= 1000 * 10;
                        this.chartDataX.unshift(new Date(_myDate).Format('hh:mm:ss'));
                        this.pm25Y.unshift(0);
                        this.pm10Y.unshift(0);
                        this.noiseY.unshift(0);
                        this.tempY.unshift(0);
                        this.wetY.unshift(0);
                        this.lightY.unshift(0);
                        this.airQualityY.unshift(0);
                        this.totalSolarRadiationY.unshift(0);
                        this.rainfallHourY.unshift(0);
                        this.rainfallMinY.unshift(0);
                        this.rainfallDayY.unshift(0);
                        this.waterQualityPhY.unshift(0);
                        this.waterQualityTurbidityY.unshift(0);
                        this.waterConductivityY.unshift(0);
                        this.waterDissolvedOxygenY.unshift(0);
                        this.waterCodY.unshift(0);
                        _index++;
                    }

                    this.chartDataX = _chartDataX
                    this.pm25Y = _pm25Y
                    this.pm10Y = _pm10Y
                    this.noiseY = _noiseY
                    this.tempY = _tempY
                    this.wetY = _wetY
                    this.lightY = _lightY
                    this.airQualityY = _airQualityY
                    this.rainfallHourY = _rainfallHourY
                    this.rainfallMinY = _rainfallMinY
                    this.rainfallDayY = _rainfallDayY
                    this.waterQualityPhY = _waterQualityPhY
                    this.waterQualityTurbidityY = _waterQualityTurbidityY
                    this.waterConductivityY = _waterConductivityY
                    this.waterDissolvedOxygenY = _waterDissolvedOxygenY
                    this.waterCodY = _waterCodY

                    this.$nextTick(() => {
                        this.fnEnviromentChart();
                    });
                    return
                }

                this.fnGetEnvironmentRecord({
                        number: this.currentEnvironmentNew.number,
                        page: 1,
                        size: 20
                    },
                    res => {
                        this.currentRecord = res.query[0];
                        this.$parent.fnGetTimes(this.currentRecord.record_at);
                        let _data = res.query;
                        for (var i = 0; i < _data.length; i++) {
                            _chartDataX.unshift(_data[i].record_at.split(' ')[1]);
                            _pm25Y.unshift(_data[i].pm2p5);
                            _pm10Y.unshift(_data[i].pm10);
                            _noiseY.unshift(_data[i].noise);
                            _tempY.unshift(_data[i].temperature);
                            _wetY.unshift(_data[i].humidity);
                            _lightY.unshift(_data[i].light);
                            _airQualityY.unshift(_data[i].air_quality);
                            _totalSolarRadiationY.unshift(_data[i].total_solar_radiation);
                            _rainfallHourY.unshift(_data[i].rainfall_hour);
                            _rainfallMinY.unshift(_data[i].rainfall_min);
                            _rainfallDayY.unshift(_data[i].rainfall_day);
                            _waterQualityPhY.unshift(_data[i].water_quality_ph);
                            _waterQualityTurbidityY.unshift(_data[i].water_quality_turbidity);
                            _waterConductivityY.unshift(_data[i].water_conductivity);
                            _waterDissolvedOxygenY.unshift(_data[i].water_dissolved_oxygen);
                            _waterCodY.unshift(_data[i].water_cod);
                        }

                        this.chartDataX = _chartDataX
                        this.pm25Y = _pm25Y
                        this.pm10Y = _pm10Y
                        this.noiseY = _noiseY
                        this.tempY = _tempY
                        this.wetY = _wetY
                        this.lightY = _lightY
                        this.airQualityY = _airQualityY
                        this.totalSolarRadiationY = _totalSolarRadiationY
                        this.rainfallHourY = _rainfallHourY
                        this.rainfallMinY = _rainfallMinY
                        this.rainfallDayY = _rainfallDayY
                        this.waterQualityPhY = _waterQualityPhY
                        this.waterQualityTurbidityY = _waterQualityTurbidityY
                        this.waterConductivityY = _waterConductivityY
                        this.waterDissolvedOxygenY = _waterDissolvedOxygenY
                        this.waterCodY = _waterCodY

                        this.$nextTick(() => {
                            this.fnEnviromentChart();
                        });
                    }, err => {
                        while (_index < 20) {
                            _myDate -= 1000 * 10;
                            this.chartDataX.unshift(new Date(_myDate).Format('hh:mm:ss'));
                            this.pm25Y.unshift(0);
                            this.pm10Y.unshift(0);
                            this.noiseY.unshift(0);
                            this.tempY.unshift(0);
                            this.wetY.unshift(0);
                            this.lightY.unshift(0);
                            this.airQualityY.unshift(0);
                            this.totalSolarRadiationY.unshift(0);
                            this.rainfallHourY.unshift(0);
                            this.rainfallMinY.unshift(0);
                            this.rainfallDayY.unshift(0);
                            this.waterQualityPhY.unshift(0);
                            this.waterQualityTurbidityY.unshift(0);
                            this.waterConductivityY.unshift(0);
                            this.waterDissolvedOxygenY.unshift(0);
                            this.waterCodY.unshift(0);
                            _index++;
                        }

                        this.chartDataX = _chartDataX
                        this.pm25Y = _pm25Y
                        this.pm10Y = _pm10Y
                        this.noiseY = _noiseY
                        this.tempY = _tempY
                        this.wetY = _wetY
                        this.lightY = _lightY
                        this.airQualityY = _airQualityY
                        this.totalSolarRadiationY = _totalSolarRadiationY
                        this.rainfallHourY = _rainfallHourY
                        this.rainfallMinY = _rainfallMinY
                        this.rainfallDayY = _rainfallDayY
                        this.waterQualityPhY = _waterQualityPhY
                        this.waterQualityTurbidityY = _waterQualityTurbidityY
                        this.waterConductivityY = _waterConductivityY
                        this.waterDissolvedOxygenY = _waterDissolvedOxygenY
                        this.waterCodY = _waterCodY

                        this.$nextTick(() => {
                            this.fnEnviromentChart();
                        });
                    });
            },
            // 环境监测统计图初始化
            fnEnviromentChart() {

                let _config = {
                    // 扬尘
                    0: [{
                        name: 'pm2.5',
                        data: 'pm25Y',
                        color: 'rgb(137,189,27)',
                        borderColor: 'rgba(137,189,2,0.27)'
                    }, {
                        name: 'pm10',
                        data: 'pm10Y',
                        color: '#fff',
                        borderColor: 'rgba(255,255,255,0.27)',
                    }, {
                        name: '噪音',
                        data: 'noiseY',
                        color: '#F56C6C',
                        borderColor: 'rgba(245,108,108,0.27)',
                    }, {
                        name: '温度',
                        data: 'tempY',
                        color: '#f29100',
                        borderColor: 'rgba(242,145,0,0.27)',
                    }, {
                        name: '湿度',
                        data: 'wetY',
                        color: '#409EFF',
                        borderColor: 'rgba(64,158,255,0.27)',
                    }],
                    // 单独扬尘
                    1: [{
                        name: 'pm2.5',
                        data: 'pm25Y',
                        color: 'rgb(137,189,27)',
                        borderColor: 'rgba(137,189,2,0.27)'
                    }, {
                        name: 'pm10',
                        data: 'pm10Y',
                        color: '#fff',
                        borderColor: 'rgba(255,255,255,0.27)',
                    }, ],
                    // 单独噪音
                    2: [{
                        name: '噪音',
                        data: 'noiseY',
                        color: '#F56C6C',
                        borderColor: 'rgba(245,108,108,0.27)',
                    }],
                    // 气象站
                    3: [{
                        name: 'pm2.5',
                        data: 'pm25Y',
                        color: 'rgb(137,189,27)',
                        borderColor: 'rgba(137,189,2,0.27)'
                    }, {
                        name: 'pm10',
                        data: 'pm10Y',
                        color: '#fff',
                        borderColor: 'rgba(255,255,255,0.27)',
                    }, {
                        name: '噪音',
                        data: 'noiseY',
                        color: '#F56C6C',
                        borderColor: 'rgba(245,108,108,0.27)',
                    }, {
                        name: '温度',
                        data: 'tempY',
                        color: '#f29100',
                        borderColor: 'rgba(242,145,0,0.27)',
                    }, {
                        name: '湿度',
                        data: 'wetY',
                        color: '#409EFF',
                        borderColor: 'rgba(64,158,255,0.27)',
                    }, {
                        name: '太阳总辐射',
                        data: 'totalSolarRadiationY',
                        color: 'rgb(178, 17, 189)',
                        borderColor: 'rgba(178,17,189,0.27)'
                    }, {
                        name: '环境光照度',
                        data: 'lightY',
                        color: 'rgb(255, 200, 0)',
                        borderColor: 'rgba(255, 200, 0,0.27)'
                    }, {
                        name: '瞬时雨量',
                        data: 'rainfallMinY',
                        color: '#f2282c',
                        borderColor: 'rgba(242,40,44,0.27)',
                    }],
                    // 污水
                    4: [{
                        name: 'PH',
                        data: 'waterQualityPhY',
                        color: '#F56C6C',
                        borderColor: 'rgba(245,108,108,0.27)',
                    }, {
                        name: '浊度',
                        data: 'waterQualityTurbidityY',
                        color: '#f29100',
                        borderColor: 'rgba(242,145,0,0.27)',
                    }, {
                        name: '导电率',
                        data: 'waterConductivityY',
                        color: '#409EFF',
                        borderColor: 'rgba(64,158,255,0.27)',
                    }, {
                        name: '溶解氧',
                        data: 'waterDissolvedOxygenY',
                        color: 'rgb(178, 17, 189)',
                        borderColor: 'rgba(178,17,189,0.27)'
                    }, {
                        name: 'COD',
                        data: 'waterCodY',
                        color: '#f2282c',
                        borderColor: 'rgba(242,40,44,0.27)',
                    }],
                    // 废气
                    5: [{
                        name: 'TVOC',
                        data: 'airQualityY',
                        color: '#409EFF',
                        borderColor: 'rgba(137,189,2,0.27)',
                    }]
                }

                let _legend = [];
                let _series = [];
                let _series_d = {
                    name: '',
                    type: 'line',
                    smooth: true,
                    symbol: 'circle',
                    symbolSize: 5,
                    showSymbol: false,
                    lineStyle: {
                        normal: {
                            width: 2
                        }
                    },
                    itemStyle: {
                        normal: {
                            color: '',
                            borderColor: '',
                            borderWidth: 12
                        }
                    },
                    data: []
                };

                let c = _config[this.type]
                for (let i in c) {
                    let series_d = JSON.parse(JSON.stringify(_series_d))

                    series_d.name = c[i].name
                    series_d.data = this[c[i].data]
                    series_d.itemStyle.normal.color = c[i].color
                    series_d.itemStyle.normal.borderColor = c[i].borderColor

                    _legend.push(c[i].name)
                    _series.push(series_d)
                }

                this.EnviromentChart = echarts.init(this.$refs.container);
                this.EnviromentChart.setOption({
                    backgroundColor: 'rgba(29,68,149,.1)',
                    title: {
                        top: 20,
                        text: '运行记录',
                        textStyle: {
                            fontWeight: 'normal',
                            fontSize: 16,
                            color: '#F1F1F3'
                        },
                        left: '1%'
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            lineStyle: {
                                color: '#57617B'
                            }
                        }
                    },
                    legend: {
                        top: '20px',
                        textStyle: {
                            color: '#fff'
                        },
                        data: _legend
                    },
                    grid: {
                        top: 100,
                        left: '2%',
                        right: '2%',
                        bottom: '2%',
                        containLabel: true
                    },
                    xAxis: [{
                        type: 'category',
                        boundaryGap: false,
                        axisLine: {
                            lineStyle: {
                                color: '#fff'
                            }
                        },
                        data: this.chartDataX
                    }],
                    yAxis: [{
                        type: 'value',
                        name: '',
                        axisTick: {
                            show: false
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#fff'
                            }
                        },
                        axisLabel: {
                            margin: 10,
                            textStyle: {
                                fontSize: 14
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#57617B'
                            }
                        }
                    }],
                    series: _series
                }, true);
            }
        },
        mounted() {}
    };
</script>

<style lang="scss" scoped>
    @import '~@/styles/mixin.scss';

    .data_box {
        width: 1600px;
        height: 778px;
        position: relative;
    }

    .details {
        position: absolute;
        width: 1260px;
        height: 500px;
        left: 10px;
        @include flex-box($wrap:wrap);

        .item_box {
            width: 300px;
            height: 240px;
            margin: 0 15px 10px 0;
            border-radius: 10px;
            background-color: rgba(29, 68, 149, 0.1);

            &:nth-child(4n) {
                margin-right: 0;
            }

            .box_title {
                width: 300px;
                height: 40px;
                line-height: 40px;
                text-align: center;
                background: url(../../../../assets/img/per_list_bg.png) no-repeat;
                background-size: 100% 100%;
                border-top-left-radius: 10px;
                border-top-right-radius: 10px;
            }

            .box_cont {
                width: 300px;
                height: 200px;
                @include flex-box(center, center);

                .cont_left {
                    width: 89px;
                    height: 200px;
                    border-right: 1px dashed #1d4495;
                    @include flex-box(center, center);

                    img {
                        width: 60px;
                        height: 60px;
                    }
                }

                .cont_right {
                    width: 210px;
                    height: 200px;
                    font-size: 18px;
                    @include flex-box(center, center, column);

                    .right_one {
                        width: 210px;
                        height: 99px;
                        border-bottom: 1px dashed #1d4495;
                        @include flex-box(center, center);

                        .t_size {
                            font-size: 28px;
                            margin: 0 3px;
                        }
                    }

                    .right_two {
                        width: 210px;
                        height: 100px;
                        @include flex-box(center, center);

                        .t_size {
                            font-size: 28px;
                            margin: 0 3px;
                        }
                    }
                }

                .left_box,
                .right_box {
                    width: 150px;
                    height: 200px;
                    @include flex-box(center, center, column);

                    .box_text {
                        font-size: 18px;
                        width: 150px;
                        height: 66.66px;
                        @include flex-box(center, center);

                        img {
                            width: 60px;
                            height: 60px;
                        }

                        .t_size {
                            font-size: 28px;
                            margin: 0 3px;
                        }
                    }
                }

                .left_box {
                    width: 149px;
                    border-right: 1px dashed #1d4495;
                }

                .cont_body {
                    width: 300px;
                    height: 200px;
                    @include flex-box(center, center);

                    img {
                        width: 60px;
                        height: 60px;
                        margin: 0 15px;
                    }

                    .text {
                        font-size: 18px;

                        .t_size {
                            font-size: 28px;
                            margin: 0 3px;
                        }
                    }
                }
            }
        }
    }

    .indicator {
        position: absolute;
        left: 1280px;
        width: 320px;
        height: 500px;
        @include flex-box(center, center, column);

        .today,
        .security {
            width: 320px;
            height: 240px;
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            margin-bottom: 10px;
            @include flex-box(center, center, column);

            .title {
                width: 320px;
                height: 50px;
                border-top-left-radius: 10px;
                border-top-right-radius: 10px;
                font-size: 24px;
                color: #fefefe;
                background: url(../../../../assets/img/per_list_bg.png) no-repeat;
                background-size: 100% 100%;
                @include flex-box(center, center);
            }

            .con {
                width: 320px;
                height: 190px;
                background-color: rgba(29, 68, 149, 0.1);
                position: relative;
                @include flex-box(space-around, center);

                .con_box {
                    width: 160px;
                    height: 190px;
                    font-size: 16px;
                    @include flex-box(flex-start, center, column);

                    &:nth-child(1) {
                        border-right: 1px dashed #1d4495;
                    }

                    .box_title {
                        width: 160px;
                        height: 70px;
                        font-size: 22px;
                        @include flex-box(center, center);
                    }

                    .box_count {
                        width: 160px;
                        height: 70px;
                        @include flex-box(center, center);

                        span {
                            color: #e03e2d;
                            font-size: 32px;
                            margin: 0 5px;
                        }
                    }

                    .box_btn {
                        width: 160px;
                        height: 50px;
                        @include flex-box(center, center);
                    }

                    .box_msg {
                        width: 160px;
                        height: 120px;
                        padding: 10px 10px;
                        @include flex-box(space-around, center);
                        flex-wrap: wrap;

                        .alarms {
                            font-size: 18px;
                        }
                    }
                }

                .safety-rate {
                    position: absolute;
                    width: 320px;
                    height: 170px;
                    @include flex-box(center, center);
                }
            }
        }
    }

    .environment_chart {
        width: 1600px;
        height: 278px;
        position: absolute;
        top: 500px;
        left: 0;

        .open-dateils {
            position: absolute;
            right: 30px;
            top: 20px;
            // .add_btn {
            // 	width: 85px;
            // 	height: 32px;
            // 	line-height: 32px;
            // 	margin: 0 2px;
            // 	font-size: 14px;
            // 	color: #ffffff;
            // 	border: none;
            // 	cursor: pointer;
            // 	background: url(../../../../assets/img/btn_bg_osm.png) no-repeat;
            // 	background-size: 100% 100%;
            // 	@include flex-box(center, center);
            // 	span {
            // 		margin-top: -2px;
            // 	}
            // }
        }

        .chart-container {
            position: relative;
            height: 260px;
            cursor: pointer;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/Environmental/environmentDefault/components/Data.vue